namespace GeniuzPOS.Member {
    export interface MbReportSaleByDateForm {
    }

    export class MbReportSaleByDateForm extends Serenity.PrefixedContext {
        static formKey = 'Member.MbReportSaleByDate';
    }
}
